import { defineComponent as _defineComponent } from 'vue'
import Icon from "@/components/widgets/icons/Icon.vue"
import { ref, watch } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionDialog',
  props: {
    show: { type: Boolean },
    title: null,
    description: null,
    buttonText: null,
    loading: { type: Boolean }
  },
  emits: ["confirm", "close"],
  setup(__props: any, { emit }: { emit: ({
  (e: "confirm"): void
  (e: "close"): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  show: boolean
  title: string
  description: string
  buttonText: string
  loading?: boolean
}





const showModal = ref(false)

watch(
  () => props.show,
  (newVal) => {
    showModal.value = newVal
  }
)

const onCloseModal = () => {
  showModal.value = false
  emit("close")
}

return { __sfc: true,emit, props, showModal, onCloseModal, Icon }
}

})